import { render, staticRenderFns } from "./AddMarketRuleObj.vue?vue&type=template&id=a1bf6562"
import script from "./AddMarketRuleObj.vue?vue&type=script&lang=js"
export * from "./AddMarketRuleObj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports